const ALL = 'all';

export const sanitizeParams = (values: Record<string, any>) => {
  const output: Record<string, any> = {};

  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (
      value == null ||
      value === '' ||
      value === ALL ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return;
    }

    output[key] = values[key];
  });
  return output;
};

export * from './number';
